module.exports = __webpack_public_path__ + "static/media/DoratLogo.7b3bf28a.png";